import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is in the img folder
import './About.css'; // Import the Premiumservices.css file

function FindOurOffice() {
  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title">your guide to our space and tools</h1>
            <p className="banner-description">
              Visit us at our office located in Kačanik, Kosovo, and let's explore how we can collaborate and create value together.
            </p>
            <a href="https://www.google.com/maps/place/Shigjeta+LLC/@42.2341388,21.2535723,17z/data=!3m1!4b1!4m6!3m5!1s0x13547b7eac0707d7:0x973e4050b61b8e86!8m2!3d42.2341349!4d21.2561472!16s%2Fg%2F11fpkh4l11?entry=ttu&g_ep=EgoyMDI1MDEwOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="banner-button">
              View on Map
            </a>
          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/About Us Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      <section className="about-section">
        {/* Section 1: Office Information */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Our Office Location</strong></h2>
            <p>
              Our office is situated in the heart of Kaçanik, Kosovo, offering easy access for both local and international clients.
            </p>
            <ul>
              <p><strong>Address:</strong> Kaçanik, Kosovo</p>
              <p><strong>Phone:</strong> +383 46 192 921</p>
              <p><strong>Email:</strong> contact@shigjeta.com</p>
            </ul>
            <a href="mailto:contact@shigjeta.com" className="banner-button">Contact Us
          </a>
          </div>
          <div className="about-image">
            <img src="/img/as3.1.png" alt="Shigjeta Office" />
          </div>
        </div>

        {/* Section 2: How to Reach Us */}
        <div className="about-row reverse" id="findme">
          <div className="about-text">
            <h2><strong>How to Reach Us</strong></h2>
            <p>
              Whether you're traveling by car or public transport, getting to our office in Kaçanik is straightforward. Our team is always ready to assist you.
            </p>
            <ul>
              <p><strong>By Car:</strong> Easily accessible via the main road.</p>
              <p><strong>By Bus:</strong> Conveniently reachable through multiple bus routes stopping nearby.</p>
              <p><strong>By Train:</strong> Just a short walk from the nearest train station.</p>
            </ul>
            <a href="https://www.google.com/maps/dir//Shigjeta+LLC,+Rr.Sali+Bajra+Ka%C4%93anik+XK,+71000/@42.2341349,21.2561472,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x13547b7eac0707d7:0x973e4050b61b8e86!2m2!1d21.2561472!2d42.2341349?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D"  target="_blank" rel="noopener noreferrer" className="banner-button">Get Directions</a>
          </div>
          <div className="about-image " alt="img">
            <img src="/img/as3.2.png" alt="How to Reach Us" />
          </div>
        </div>
      </section>
    </>
  );
}

export default FindOurOffice;
